import { render, staticRenderFns } from "./SkillButton.vue?vue&type=template&id=a79da1e2&scoped=true"
import script from "./SkillButton.vue?vue&type=script&lang=js"
export * from "./SkillButton.vue?vue&type=script&lang=js"
import style0 from "./SkillButton.vue?vue&type=style&index=0&id=a79da1e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79da1e2",
  null
  
)

export default component.exports